"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_1 = require("../lib");
const GraphandModelList_1 = __importDefault(require("../lib/GraphandModelList"));
const GraphandModelListPromise_1 = __importDefault(require("../lib/GraphandModelListPromise"));
const GraphandModelPromise_1 = __importDefault(require("../lib/GraphandModelPromise"));
const GraphandQuery_1 = __importDefault(require("../lib/GraphandQuery"));
function getModelList(Model, _q, _opts = true) {
    if (!Model._client) {
        throw new Error(`Model ${Model.scope} is not registered`);
    }
    const defaultOptions = { fetch: true, cache: true };
    const opts = Object.assign({}, defaultOptions, typeof _opts === "object" ? _opts : { fetch: _opts });
    const { fetch, cache } = opts;
    const query = new GraphandQuery_1.default(Model, _q);
    let list = query.getCachedList();
    if (!list && query.ids) {
        if (query.ids instanceof GraphandModelList_1.default || query.ids instanceof GraphandModelListPromise_1.default) {
            query.ids = query.ids.ids;
        }
        else if (query.ids instanceof lib_1.GraphandModel || query.ids instanceof GraphandModelPromise_1.default) {
            query.ids = [query.ids._id];
        }
        else if (typeof query.ids === "string") {
            query.ids = [query.ids];
        }
        if (cache && query.isMergeable()) {
            const cacheList = query.ids.map((_id) => Model.get(_id, false));
            if (cacheList.every(Boolean)) {
                list = new GraphandModelList_1.default({ model: Model, count: cacheList.length, query, rows: cacheList });
            }
        }
    }
    if (!list && fetch) {
        return new GraphandModelListPromise_1.default(async (resolve) => {
            var _a, _b;
            try {
                await Model._init();
                let graphandModelList;
                const fetchOpts = typeof fetch === "object" ? fetch : {};
                fetchOpts.cache = (_a = fetchOpts.cache) !== null && _a !== void 0 ? _a : cache;
                const { rows, count } = await query.execute(fetchOpts);
                const storeList = Model._listSubject.getValue();
                if (query.isMergeable()) {
                    const _list = ((_b = query.ids) === null || _b === void 0 ? void 0 : _b.map((_id) => storeList.find((item) => item._id === _id)).filter(Boolean)) || [];
                    graphandModelList = new GraphandModelList_1.default({ model: Model, count: _list.length, query, rows: _list });
                }
                else {
                    const _list = rows.map((row) => storeList.find((item) => item._id === row._id)).filter(Boolean) || [];
                    graphandModelList = new GraphandModelList_1.default({ model: Model, count, query, rows: _list });
                }
                return resolve(graphandModelList);
            }
            catch (e) {
                console.error(e);
                return resolve(new GraphandModelList_1.default({ model: Model, query }));
            }
        }, Model, query);
    }
    return list;
}
exports.default = getModelList;
